export const getAuthToken = (): string => {
  const tokenJson = localStorage.getItem("token");

  let token = "";

  if (tokenJson) {
    token = JSON.parse(tokenJson);
  }

  return token;
};

export const saveAuthToken = (token: string) => {
  localStorage.setItem("token", JSON.stringify(token));
};

export const clearAuthToken = () => {
  localStorage.removeItem("token");
};
